import { createAction } from '../utils';
import { DraftType } from './types';
export var setValue = createAction(DraftType.SET_VALUE);
export var setArrayValue = createAction(DraftType.SET_ARRAY_VALUE);
export var setTouched = createAction(DraftType.SET_TOUCHED);
export var submitAttempt = createAction(DraftType.SUBMIT_ATTEMPT);
